import type { Client, AuthenticationProvider } from '@microsoft/microsoft-graph-client';
import { makeGraphClient } from '@repancy/graph-core';
import { acquireGraphToken } from './msalClient';

class MsalAuthProvider implements AuthenticationProvider {
  async getAccessToken(): Promise<string> {
    return acquireGraphToken();
  }
}

let client: Client | null = null;

/**
 * Lazily build the singleton Graph client backed by MSAL. The provider re-acquires
 * tokens silently on every call, so the client picks up fresh access tokens
 * automatically when the cached one expires.
 *
 * The factory itself lives in `@repancy/graph-core` so the Azure worker can
 * mint its own client with a Managed-Identity provider without depending on
 * MSAL. The SPA owns the singleton + the test hook.
 */
export function getGraphClient(): Client {
  if (client) return client;
  client = makeGraphClient(new MsalAuthProvider());
  return client;
}

/** For tests: replace the singleton with a stub Client. */
export function __setGraphClientForTests(stub: Client | null) {
  client = stub;
}
